import React from 'react'
import { Button, Spinner, Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as FulfilledAlertIcon } from 'static/svg/fulfilled-alert-icon.svg'
import { ReactComponent as RemoveSlotIcon } from 'static/svg/remove-slot-icon.svg'

import * as S from './styles'

interface SlotTagProps {
  startTime: string
  endTime: string
  onRemoveSlot: () => void
  loading?: boolean
  error?: boolean
}

interface StatusIconProps {
  loading: boolean
  error: boolean
  handleRemoveSlot: () => void
}

const StatusIcon = ({ loading, error, handleRemoveSlot }: StatusIconProps) => {
  if (loading) {
    return <Spinner customClassName='iconSpinner' /> 
  }

  if (error) {
    return <FulfilledAlertIcon />
  }

  return (
    <Button onClick={handleRemoveSlot}>
      <RemoveSlotIcon />
    </Button>
  )
}

export const SlotTag: React.FC<SlotTagProps> = ({
  startTime,
  endTime,
  onRemoveSlot,
  loading,
  error
}) => {
  
  return (
    <S.Container hasError={error}>
      
      <Typography variant='content2' customClassName='slotTagTime'>
        {startTime} às {endTime}
      </Typography>
        
      <S.IconWrapper>
        <StatusIcon 
          loading={loading} 
          error={error} 
          handleRemoveSlot={onRemoveSlot}  
        />
      </S.IconWrapper>
    </S.Container>
  )
}